import { isElementType } from '@lumapps/wrex/slate/utils/isElementType';

import { T_D } from '../constants';

export const isTableCell = isElementType(T_D);
